'use client';

import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, ReferenceLine
} from 'recharts';

const data = [
  { time: '06:00', events: 3240, blocked: 180, anomaly: 0 },
  { time: '07:00', events: 3820, blocked: 210, anomaly: 0 },
  { time: '08:00', events: 5120, blocked: 340, anomaly: 1 },
  { time: '09:00', events: 4890, blocked: 290, anomaly: 0 },
  { time: '10:00', events: 6740, blocked: 520, anomaly: 1 },
  { time: '11:00', events: 7230, blocked: 680, anomaly: 1 },
  { time: '12:00', events: 5980, blocked: 410, anomaly: 0 },
  { time: '13:00', events: 4320, blocked: 260, anomaly: 0 },
  { time: '14:00', events: 8910, blocked: 890, anomaly: 1 },
  { time: '15:00', events: 7640, blocked: 720, anomaly: 0 },
  { time: '16:00', events: 6230, blocked: 540, anomaly: 0 },
  { time: '17:00', events: 5110, blocked: 380, anomaly: 0 },
  { time: '18:00', events: 4780, blocked: 290, anomaly: 0 },
  { time: '19:00', events: 9230, blocked: 1120, anomaly: 1 },
  { time: '20:00', events: 7890, blocked: 940, anomaly: 0 },
  { time: '21:00', events: 6340, blocked: 710, anomaly: 0 },
  { time: '22:00', events: 4920, blocked: 460, anomaly: 0 },
  { time: '23:00', events: 5640, blocked: 520, anomaly: 0 },
  { time: '00:00', events: 3890, blocked: 310, anomaly: 0 },
  { time: '01:00', events: 2940, blocked: 180, anomaly: 0 },
  { time: '02:00', events: 2310, blocked: 120, anomaly: 0 },
  { time: '03:00', events: 3120, blocked: 190, anomaly: 0 },
  { time: '04:00', events: 4890, blocked: 380, anomaly: 1 },
  { time: '05:00', events: 4218, blocked: 340, anomaly: 0 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2.5 shadow-xl text-xs">
      <p className="font-mono text-zinc-400 mb-1.5">{label}</p>
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-rose-500"></span>
          <span className="text-zinc-400">Olaylar:</span>
          <span className="font-semibold text-zinc-200 tabular-nums">{payload[0]?.value?.toLocaleString()}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-amber-500"></span>
          <span className="text-zinc-400">Engellenen:</span>
          <span className="font-semibold text-amber-400 tabular-nums">{payload[1]?.value?.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default function EventVolumeChart() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-zinc-200">Olay Hacmi — Son 24 Saat</h3>
          <p className="text-xs text-zinc-500 mt-0.5">IDS/IPS kurallarıyla alınan ve engellenen toplam olaylar</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1.5">
            <span className="w-2.5 h-0.5 bg-rose-500 rounded-full"></span>
            <span className="text-[11px] text-zinc-500">Olaylar</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2.5 h-0.5 bg-amber-500 rounded-full"></span>
            <span className="text-[11px] text-zinc-500">Engellenen</span>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <AreaChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="eventsGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#e11d48" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#e11d48" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="blockedGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="hsl(240 4% 14%)" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="time"
            tick={{ fontSize: 10, fill: '#52525b', fontFamily: 'IBM Plex Mono' }}
            tickLine={false}
            axisLine={false}
            interval={3}
          />
          <YAxis
            tick={{ fontSize: 10, fill: '#52525b', fontFamily: 'IBM Plex Mono' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}
          />
          <Tooltip content={<CustomTooltip />} />
          <ReferenceLine y={7000} stroke="#ef4444" strokeDasharray="4 4" strokeOpacity={0.4} label={{ value: 'Eşik', fill: '#ef4444', fontSize: 9 }} />
          <Area type="monotone" dataKey="events" stroke="#e11d48" strokeWidth={1.5} fill="url(#eventsGrad)" />
          <Area type="monotone" dataKey="blocked" stroke="#f59e0b" strokeWidth={1.5} fill="url(#blockedGrad)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}